import { PhCalendar } from '@phosphor-icons/vue'

import { isBrandBoostOnly } from '@/features/billing/queries/useActiveBrandPlans'
import { MIB_GATES_FLAG } from '@/features/upsell/featureFlags'
import UpsellGateBadge from '@/features/upsell/public/UpsellGateBadge.vue'
import { openUpsellSheet } from '@/features/upsell/sheetState'
import { UpsellSource } from '@/features/upsell/upsellTracking'
import { isReservationsGated } from '@/features/website-builder/gating'
import { type BuilderBlockModule } from '@/lib/builder/types'
import { FeatureFlags } from '@/plugins/featureFlags'
import i18nPlugin from '@/plugins/i18n'

import {
  type WebsiteResource,
  type ReservationEmbedSection,
  type ReservationEmbedSectionCreate,
  type ReservationEmbedSectionUpdate,
} from '../../WebsiteBuilder.types'
import { websiteBlockMethods } from '../common/methods'

import ReservationEmbedEditor from './editor/ReservationEmbedEditor.vue'
import { createReservationEmbedData } from './methods/createReservationEmbedData'
import ReservationEmbedPreview from './preview/ReservationEmbedPreview.vue'

const i18n = i18nPlugin.global

export const ReservationEmbedBlockModule: BuilderBlockModule<
  ReservationEmbedSection,
  ReservationEmbedSectionCreate,
  ReservationEmbedSectionUpdate,
  WebsiteResource
> = {
  // Gated Boost-only brands keep the option visible (badge + upsell modal via
  // gatedAdd); any other gated brand has it hidden outright. The backend 403s
  // creates either way.
  canAdd: () =>
    !isReservationsGated(FeatureFlags.isEnabled(MIB_GATES_FLAG)) ||
    isBrandBoostOnly(),
  createData: createReservationEmbedData,
  editor: ReservationEmbedEditor,
  gatedAdd: () => isReservationsGated(FeatureFlags.isEnabled(MIB_GATES_FLAG)),
  meta: [
    {
      gateBadge: UpsellGateBadge,
      icon: PhCalendar,
      key: 'reservation-embed',
      label: i18n.t('website-builder.blocks.reservation-embed'),
    },
  ],
  methods: websiteBlockMethods,
  onGatedAdd: () =>
    openUpsellSheet(UpsellSource.websiteBuilderReservationEmbedAdd),
  preview: ReservationEmbedPreview,
}
